import { Form } from 'antd';
import React from 'react';
import styled from '@emotion/styled';

type WithFormItemProps = {
  label?: any;
  instructiveLabel?: React.ReactNode;
  htmlFor?: string;
  error?: { message: string };
  children?: React.ReactNode;
  componentType?: string;
};

const FormItem = styled(Form.Item)<{ ishidden: string }>`
  display: ${({ ishidden }) => ishidden};
  & {
    .ant-form-item-row {
      display: block;
    }
  }
  && {
    .ant-form-item-label {
      line-height: 24px;
      padding: 9px 0;
      white-space: normal;
      text-align: left;
    }
    label {
      div {
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }
`;

const WithFormItem = function WithFormItem({
  label,
  instructiveLabel,
  htmlFor,
  error,
  children,
  componentType,
}: WithFormItemProps) {
  return (
    <FormItem
      ishidden={componentType && componentType === 'hidden' ? 'none' : 'block'}
      label={label}
      htmlFor={htmlFor}
      colon={false}
      validateStatus={error ? 'error' : ''}
      help={error && error.message}
    >
      {instructiveLabel}
      {children}
    </FormItem>
  );
};

export default React.memo(WithFormItem);
